/**
 * @generated SignedSource<<404f0936c589f2bac5fc9b25c6f0c25c>>
 * @relayHash 6139c5ac9eede3cb4cb45119f82b6c42
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 73bb0607fa286f014e98ee150a452d0808aff2ce4aa135ef04b8f21d5ea34326

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraDeploymentsFeaturePrecondition = "ALL_SATISFIED" | "DEPLOYMENTS_EMPTY_STATE" | "NOT_AVAILABLE" | "%future added value";
export type latestDeploymentForVersionPreconditionQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type latestDeploymentForVersionPreconditionQuery$data = {
  readonly jira: {
    readonly deploymentsFeaturePreconditionByProjectKey: JiraDeploymentsFeaturePrecondition | null | undefined;
  };
};
export type latestDeploymentForVersionPreconditionQuery = {
  response: latestDeploymentForVersionPreconditionQuery$data;
  variables: latestDeploymentForVersionPreconditionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        }
      ],
      "kind": "ScalarField",
      "name": "deploymentsFeaturePreconditionByProjectKey"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "latestDeploymentForVersionPreconditionQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v1/*: any*/),
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "latestDeploymentForVersionPreconditionQuery",
    "selections": [
      (v1/*: any*/)
    ]
  },
  "params": {
    "id": "73bb0607fa286f014e98ee150a452d0808aff2ce4aa135ef04b8f21d5ea34326",
    "metadata": {},
    "name": "latestDeploymentForVersionPreconditionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "af15b08c11e01f89f1bd0ec84b873d12";

export default node;
